import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Noah Brown",
        title: "Venue Specialist",
        biography: "Noah Brown is an experienced Venue Specialist known for his expertise in selecting and managing the perfect locations for a wide range of events. His vast knowledge of venues and attention to detail ensures that every event is matched with the ideal setting. Noah's hands-on approach and dedication to finding unique and memorable venues make him an indispensable member of our team.",
        contacts: {
            phone: "555-456-7890",
            email: "noah.brown@example.com",
            website: "www.noahbrownvenues.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Venue Selection",
            "Vendor Coordination",
            "Event Logistics",
            "Site Management",
            "Contract Negotiation"
        ],
        skills: [
            { id: 1, title: "Venue Selection", progress: 95 },
            { id: 2, title: "Vendor Coordination", progress: 90 },
            { id: 3, title: "Contract Negotiation", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Emma Johnson",
        title: "Event Manager",
        biography: "Emma Johnson is a seasoned Event Manager known for her exceptional organizational skills and dedication to delivering flawless events. With years of experience in managing large-scale events, Emma has a keen eye for detail and a strong ability to coordinate every aspect of an event, from concept to execution. Her expertise includes logistics, team coordination, and client relations, making her a vital asset to our team.",
        contacts: {
            phone: "555-123-4567",
            email: "emma.johnson@example.com",
            website: "www.emmajohnsonevents.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Event Manager at Prestige Events",
            "Assistant Event Manager at Grand Occasions",
            "Event Coordinator at Corporate Affairs",
            "Freelance Event Planning",
            "Event Logistics Specialist"
        ],
        skills: [
            { id: 1, title: "Event Coordination", progress: 95 },
            { id: 2, title: "Logistics Management", progress: 90 },
            { id: 3, title: "Client Relations", progress: 85 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "James Carter",
        title: "Logistics Coordinator",
        biography: "James Carter is an experienced Logistics Coordinator with a strong background in organizing and managing event logistics. His expertise in handling transportation, venue setup, and vendor coordination ensures that every event runs smoothly. James excels in managing complex logistics and thrives under pressure, making him an invaluable member of our team.",
        contacts: {
            phone: "555-789-0123",
            email: "james.carter@example.com",
            website: "www.jamescarterlogistics.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Logistics Coordinator at Event Pro Services",
            "Logistics Manager at Global Events",
            "Supply Chain Specialist at Event Logistics",
            "Event Operations Supervisor",
            "Freelance Event Coordinator"
        ],
        skills: [
            { id: 1, title: "Logistics Management", progress: 95 },
            { id: 2, title: "Vendor Coordination", progress: 90 },
            { id: 3, title: "Event Setup", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Olivia Brooks",
        title: "Design Expert",
        biography: "Olivia Brooks is a talented Design Expert with a keen eye for aesthetics and a passion for creating visually stunning event designs. With years of experience in event décor and styling, Olivia specializes in transforming spaces into captivating environments that reflect the unique vision of each event. Her attention to detail and creativity are key in bringing ideas to life, making every event unforgettable.",
        contacts: {
            phone: "555-234-5678",
            email: "olivia.brooks@example.com",
            website: "www.oliviabrooksdesigns.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Senior Designer at Creative Event Solutions",
            "Lead Designer at Elegant Weddings",
            "Event Stylist at Luxe Design Studios",
            "Freelance Event Decorator",
            "Design Consultant for Corporate Events"
        ],
        skills: [
            { id: 1, title: "Event Design", progress: 95 },
            { id: 2, title: "Space Planning", progress: 90 },
            { id: 3, title: "Floral Arrangements", progress: 85 }
        ]
    }
];

export default team;